import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth/signUp';

import { validateSignUpFieldValue } from './utils';

export default function* listenSetSignUpFieldValue() {
  yield takeEvery(actionTypes.setSignUpFieldValue, validateSignUpFieldValue);
}
